import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useCreateRepost } from "../api/createRepost";
import { useState } from "react";
import _cookies from "../../../shared/utils/_cookies";

export default function Repost({ postData, children }) {
  const [openDialog, setDialogOpen] = useState(false);
  const createRepostMutation = useCreateRepost();
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const handleConfirm = () => {
    createRepostMutation.mutate(
      { postId: postData.postagemid },
      {
        onSuccess: () => {
          handleCloseDialog();
        },
      }
    );
  };
  const methods = {
    openDialog: handleOpenDialog,
    closeDialog: handleCloseDialog,
  };

  return (
    <>
      {children(methods)}
      <Dialog open={openDialog} maxWidth={"xs"} fullWidth>
        <IconButton
          sx={{ position: "absolute", top: 3, right: 3 }}
        ></IconButton>
        <DialogTitle>Confimar</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza que você quer repostar esse conteúdo em seu feed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancelar</Button>
          <Button onClick={handleConfirm} variant="contained">
            Repostar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
